import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import ApartmentFreeTooltip from './ApartmentFreeTooltip';
import { Icon } from './Icon';

export interface IApartmentProps {
  children: React.JSX.Element;
  count: number;
  isFreeApartmentWithIntercom?: boolean;
  isError?: boolean;
  isFreeApartmentWithAnsweringUnit?: boolean;
  isLastChild?: boolean;
  tooltip?: boolean;
}

function Apartment({
  children,
  count,
  isError,
  isFreeApartmentWithAnsweringUnit,
  isFreeApartmentWithIntercom,
  isLastChild,
  tooltip,
}: IApartmentProps) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        mb: !isLastChild
          ? {
              sm: 1.5,
              xs: 0.5,
            }
          : undefined,
      }}
    >
      <Box sx={{ alignItems: 'center', display: 'flex', mr: 1 }}>
        <Icon count={count} isError={isError} />
      </Box>
      {tooltip ? (
        <ApartmentFreeTooltip
          count={count}
          isFreeApartmentWithIntercom={isFreeApartmentWithIntercom}
          isFreeApartmentWithAnsweringUnit={isFreeApartmentWithAnsweringUnit}
        >
          {children}
        </ApartmentFreeTooltip>
      ) : (
        <Typography color={count > 0 ? 'text.primary' : 'text.disabled'} component="div" noWrap variant="body2">
          {children}
        </Typography>
      )}
    </Box>
  );
}

export default Apartment;
